<template>
  <el-cascader v-bind="$attrs"
               v-on="$listeners"
               :options="options"
               :filterable="true"
               :props="{ expandTrigger: 'hover' }">
  </el-cascader>
</template>

<script>
  export default {
    name: 'BrandSelect',
    created () {
      this.$store.dispatch('data/kvList', 'BrandModel')
    },
    data () {
      return {}
    },
    methods: {
      convertData (item) {
        const ret = {
          label: item.name,
          value: item.id,
          children: []
        }
        for (const model of item.models) {
          ret.children.push({
            label: model,
            value: model
          })
        }
        return ret
      }
    },
    computed: {
      options () {
        const options = []
        for (const item of this.$store.state.data.BrandModel || []) {
          options.push(this.convertData(item))
        }
        return options
      }
    }
  }
</script>

<style scoped>
</style>
